import { createContext, useCallback, useContext, useEffect, useMemo, useRef } from 'react'
import { getAuthGeneration } from 'utils/auth'

/** Logical private workspace ownership; purpose-token renewal is not a new owner. */
export const ToolRenewalContext = createContext(false)
export const ToolOwnershipContext = createContext<string | null>(null)
export function useToolOwnership(fallback: string, resource = '') {
  const inherited = useContext(ToolOwnershipContext)
  const key = `${inherited ?? fallback}:${resource}:${getAuthGeneration()}`
  const current = useRef({ key, epoch: 0 })
  if (current.current.key !== key) current.current = { key, epoch: current.current.epoch + 1 }
  const mounted = useRef(true)
  useEffect(() => { mounted.current = true; return () => { mounted.current = false } }, [])
  const capture = useCallback(() => {
    const owner = current.current
    const auth = getAuthGeneration()
    return () => mounted.current && current.current === owner && getAuthGeneration() === auth
  }, [])
  return useMemo(() => ({ key, capture }), [key, capture])
}
